export enum AdminCosmeticListItemAction {
  Edit,
  Preview,
  Remove,
}
